export const radii = {
  none: 0,
  xsmall: 4,
  small: 6,
  medium: 8,
  large: 12,
  xlarge: 16,
  full: 9999
};
